<script setup lang="ts">
  defineProps({
    header: String,
    header_type: String,
    content: String,
    photos: Array,
  });
</script>
<template>
  <section class="photo-text">
    <div class="photo-text__content  section-wrapper container">
      <SegmentHeading larger :type="header_type || 'h2'" class="photo-text__header">
        {{ header }}
      </SegmentHeading>
      <MediaPicture :photo="photos" type="photo" class="photo-text__image" sizes="1984x1488 2x max 992,992x744 max 992,1400x1050 2x, 700x525" />
      <div class="section-typography" v-html="content" />
    </div>
  </section>
</template>
<style scoped lang="scss">
  .photo-text {

    &__content::after {
      content: '';
      clear: both;
    }

    &__header {
      margin-bottom: 2.5rem;

      &::after {
        display: none;
      }
    }

    :deep(.photo-text__image) {
      float: left;
      width: 50%;
      margin: 0 2rem 2rem 0;

      img {
        object-fit: cover;
      }
    }
  }

  @media (max-width: 992px) {
    .photo-text {
      display: flex;
      flex-direction: column;
      padding: 0 1rem;

      &__content{
        display: flex;
        flex-direction: column;
        gap:  1rem;
      }

      &__header {
        margin-bottom: 0;
        font-size: 1.5rem;
      }

      :deep(.photo-text__image) {
        float: none;
        width: 100%;
        margin: 1rem 0 0 0;
        order: 3;
      }
    }
  }
</style>
